/**
 * Builds a dataset 'in-period' date filter for the current period, using the
 * given date field
 *
 * @param {Object} selected
 *
 * @param {Number} selected.fieldId the selected underlying field ID
 *
 * @param {Number} [selected.visibleLinkedFieldId] the visible linked field ID
 * if the field is linked
 */
function currentPeriodDatasetFilter (selected) {
	return {
		fieldId: selected.fieldId,
		visibleLinkedFieldId: selected.visibleLinkedFieldId,
		operator: 'in-period',
		periodDelta1: 0,
		periodDelta2: 0
	}
}

export default currentPeriodDatasetFilter

currentPeriodDatasetFilter.__filename__ = 'dashboards/widgets/current-period-dataset-filter.js'
